import { request } from "../http/api-client";
import type { Webhook, WebhookValidation, Pagination } from "../types";

export async function listWebhooks(page = 1, limit = 10): Promise<{ webhooks: Webhook[]; pagination: Pagination }> {
  const res = await request<{ success: boolean; data: { webhooks: Webhook[]; pagination: Pagination } }>(`/api/v1/webhooks?page=${page}&limit=${limit}`, { method: "GET" });
  const data = res.data || { webhooks: [], pagination: { page, limit, total: 0, pages: 0 } };
  return data;
}

export async function createWebhook(payload: { url: string; eventTypes: string[]; description?: string; isActive?: boolean }): Promise<Webhook> {
  const res = await request<{ success: boolean; data: Webhook }>(`/api/v1/webhooks`, {
    method: "POST",
    body: payload,
  });
  return res.data;
}

export async function validateWebhookUrl(payload: { url: string; method?: string; timeout?: number }): Promise<WebhookValidation> {
  const res = await request<{ success: boolean; data: WebhookValidation }>(`/api/v1/webhooks/validate-url`, {
    method: "POST",
    body: { url: payload.url, method: payload.method || "POST", timeout: payload.timeout ?? 10000 },
  });
  return res.data;
}

export async function deleteWebhook(id: string): Promise<void> {
  await request(`/api/v1/webhooks/${id}`, { method: "DELETE" });
}
